import * as ActionTypes from '../../../constants';

const initialState = {
  isVisible: false,
  text: '',
  // A busy toast carries the inline spinner and is NOT auto-hidden — it stays up for the length of
  // the operation that showed it (see actions/toast.js `showBusyToast`).
  isBusy: false,
  // Bumped on every SHOW_TOAST. `showToast`'s auto-hide timer is tagged with the generation it
  // created, and HIDE_TOAST ignores a tag that is no longer current — otherwise a stale timer from
  // an earlier toast hides a newer one, which would kill a busy toast mid-operation.
  generation: 0
};

const toast = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SHOW_TOAST:
      return Object.assign({}, state, {
        isVisible: true,
        isBusy: !!action.isBusy,
        // `text` is optional: the legacy two-action syntax sets it via SET_TOAST_TEXT first.
        text: action.text === undefined ? state.text : action.text,
        generation: state.generation + 1
      });
    case ActionTypes.HIDE_TOAST:
      // An untagged HIDE_TOAST (the close button, an explicit dismissal) always hides.
      if (
        action.generation !== undefined &&
        action.generation !== state.generation
      ) {
        return state;
      }
      return Object.assign({}, state, { isVisible: false, isBusy: false });
    case ActionTypes.SET_TOAST_TEXT:
      return Object.assign({}, state, { text: action.text });
    default:
      return state;
  }
};

export default toast;
